import {
  FrequentFlyerCard,
} from '@dapi/sdk';
import {
  traveler,
  traveler2,
} from './traveler';

export const frequentFlyerCard: FrequentFlyerCard = {
  id: 'OT24',
  companyCode: 'LH',
  cardNumber: '222012009749273',
  travelerId: traveler.id,
  tierLevel: 'G',
  priorityCode: '1',
  allianceTierLevel: 'G'
};

export const frequentFlyerCard2: FrequentFlyerCard = {
  ...frequentFlyerCard,
  id: 'OT25',
  cardNumber: '222012009749274',
  travelerId: traveler2.id
};
